import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    product: Yup.object().required("common:validator.required"),
    version: Yup.object().required("common:validator.required"),
  });
};
